<template>

    <div class="row" id="login">
        <div class="login_box">
            <div class="login_image_container">
                <img src="../assets/images/clockit_login.png" class="login_image" />
            </div>
            <div class="login_form_container">
                <form action="#" @submit.prevent="login">
                    <br />
                    <div class="form-group">
                        <input type="email" class="form-control" v-bind:placeholder="$t('place_holder.email')" v-model="email">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" v-bind:placeholder="$t('place_holder.password')" v-model="password">
                    </div>

                    <div class="form-group">
                        <span v-if="this.errormsg" align="center"><p class="text-danger">{{ errormsg }}</p></span>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-default login-submit form-control">{{ $t('button.sign_in') }}</button>
                    </div>
                    <div class="form-group align_left_lang">
                        <!-- app-lang-switcher / -->
                    </div>
                    <div class="form-group forgot_password_link">
                        <span class="mt-10">
                            <router-link :to="`/${$i18n.locale}/forgotpassword`">{{ $t('password.forgot_password') }}</router-link>
                        </span>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
import i18n from '../i18n';
import LanguageSwitcher from './shared/LanguageSwitcher';
import { error } from 'util';

export default {
    components: {
        'app-lang-switcher': LanguageSwitcher
    },

    data () {
        return {
            email: '',
            password: '',
            title: 'LOGIN',
            adminId: null,
            errormsg: null,
        }
    },

    methods: {
        login() {
            let lang = this.$i18n.locale

            this.$store.dispatch('retriveToken', {
                email: this.email,
                password: this.password
            })
            .then(response => {
                this.retriveToken(lang)
            })
            .catch(error => {
                this.errormsg = 'Unable to login. User / Password not valid'
            })
        },

        retriveToken(locale) {
            let jwtCode = require('jwt-decode')
            let decodedToken = jwtCode(this.$store.state.token)
            //console.log(decodedToken);
            this.adminId = decodedToken.id;

            if (this.adminId) {
                this.$store.dispatch('retriveUserName', this.adminId)
                .then(response2 => {
                    this.$router.push(locale + '/home')
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
    },

    mounted() {
        //localStorage.clear();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue